'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n\twidth: 100%;\n  border-radius: ', ';\n  cursor: ', ';\n'], ['\n\twidth: 100%;\n  border-radius: ', ';\n  cursor: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\toverflow: hidden;\n  border-radius: ', ';\n  width: ', ';\n  height: ', ';\n'], ['\n\toverflow: hidden;\n  border-radius: ', ';\n  width: ', ';\n  height: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Image = _styledComponents2.default.img(_templateObject, function (props) {
  return props.variant === 'circle' ? '50%' : '';
}, function (props) {
  return props.onClick ? 'pointer' : '';
});

var ImageContainer = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.variant === 'overlay-circle' ? '50%' : '';
}, function (props) {
  return props.variant === 'overlay-circle' && props.style.width ? props.style.width + ';' : '100px';
}, function (props) {
  return props.variant === 'overlay-circle' && props.style.height ? props.style.height + ';' : '100px';
});

var MozartImage = function MozartImage(props) {
  var src = props.src,
      alt = props.alt,
      style = props.style,
      onClick = props.onClick,
      variant = props.variant,
      themeId = props.themeId;

  var imgStyle = {
    width: style.width ? style.width : '100px'
  };
  return _react2.default.createElement(
    ImageContainer,
    { 'data-qa': props.testId, variant: variant, style: style, 'data-theme': themeId },
    _react2.default.createElement(Image, {
      variant: variant,
      onClick: onClick,
      style: variant !== 'overlay-circle' ? style : imgStyle,
      src: src,
      alt: alt })
  );
};

MozartImage.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** src of the image */
  src: _propTypes2.default.string.isRequired,
  /** image alt */
  alt: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** variant could be circle, overlay-circle or rectangle */
  variant: _propTypes2.default.string,
  /** callback onClick */
  onClick: _propTypes2.default.func
};

MozartImage.defaultProps = {
  alt: 'Image Placeholder',
  variant: 'rectangle',
  style: {},
  testId: 'MozartImage',
  themeId: 'MozartImage'
};

exports.default = MozartImage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartImage/MozartImage.js
// module id = 1835
// module chunks = 1